import styled from 'styled-components';

const SectionSubHeader = styled.h2`
  color: ${(props) => props.theme.primary};
  width: 100%;
  margin: 0;
  font-size: 24px;
  font-weight: 700;
`;

export default SectionSubHeader;
